export const NO_USAGE_ALIAS = '未使用者';
export const DATA_SOURCE_STORAGE_KEY = 'usage_dashboard_data_source';
